import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thumbnailPipe'
})
export class ThumbnailPipePipe implements PipeTransform {

  transform(value: string): any {
    let url;
    url = value.split('=')[1];
    let thumbnail;
    thumbnail = `http://img.youtube.com/vi/${url}/mqdefault.jpg`;
    return thumbnail;
  }

}
